import { ReadFile } from '@paragon/client-tools';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import pPostUploadFiles from '../data/componentsConnection';
import { setLoadingFiles } from '../store/loadingFilesSlice';
import { loadTruckloads } from '../store/packingSlice';
import { AsyncThunkActionVoid } from './thunkActions';

export default (files: readonly ReadFile[]): AsyncThunkActionVoid =>
  async (dispatch, getState) => {
    const oldFiles = getState().loadingFiles;
    dispatch(setLoadingFiles(files));

    let spinnerId: number | null = null;

    if (!oldFiles) {
      spinnerId = dispatch(addSpinnerMessage('Packing...'));
    }
    let truckloads = null;
    try {
      truckloads = await pPostUploadFiles(files);
    } catch (exception) {
      console.error(exception);
      window.alert('Exception thrown while uploading files.');
    } finally {
      if (getState().loadingFiles === files) {
        dispatch(setLoadingFiles(null));
        if (truckloads) {
          dispatch(loadTruckloads(truckloads));
        }

        if (spinnerId != null) {
          dispatch(removeSpinnerMessage(spinnerId));
        }
      }
    }
  };
